import MobileInput from './mobile-input.vue'
export type { MobileInputProps } from './props'
export default MobileInput